import { ContactApi } from '../api-typings/contacts/contacts';
import { isDefined } from '../helpers';
import { transformUser } from '../user/user.transformers';
import { Contact } from './contact.model';

export function transformContact(contact: ContactApi): Contact {
  const weights = Object.values(contact.relationships)
    .map(relationship => relationship.weight)
    .filter(isDefined);

  return {
    ...transformUser(contact.user),
    maxWeight: Math.max(0, ...weights),
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/contact/contact.transformers.ts